import { cn } from '@nextui-org/react'
import React from 'react'

interface CurieInputProps {
  id?: string
  placeholder?: string
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  defaultValue?: string
  className?: string
  autoComplete?: string
  type?: 'email' | 'password' | 'text'
  autoFocus?: boolean
  disabled?: boolean
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  height?: 'sm' | 'md' | 'lg'
}

export function Input({
  id,
  placeholder,
  value,
  onChange,
  defaultValue,
  className = '',
  type = 'text',
  autoComplete = 'off',
  autoFocus = false,
  disabled = false,
  onBlur = undefined,
  onKeyDown = undefined,
  height = 'md'
}: CurieInputProps) {
  const getHeightStyles = () => {
    switch (height) {
      case 'sm':
        return 'h-8 px-4 py-1.5'
      case 'md':
        return 'h-10 px-6 py-2.5'
      case 'lg':
        return 'h-12 px-6 py-3'
      default:
        return 'h-10 px-6 py-2.5'
    }
  }

  return (
    <input
      id={id}
      className={cn(
        // Base styles
        'w-full rounded-xl',
        'text-sm font-["Geist"] leading-tight tracking-tight',
        getHeightStyles(),

        // Border styles
        'border border-input-border',

        // Text and placeholder colors
        'text-neutral-800',
        'placeholder:text-neutral-400',

        // Background and states
        'bg-white',
        'hover:shadow transition-shadow duration-200',
        'focus:shadow focus:outline-none focus:border-input-border',

        // Disabled state
        'disabled:bg-surface/10',
        'disabled:border-surface/10',
        'disabled:text-neutral-400',
        'disabled:cursor-not-allowed',

        className
      )}
      disabled={disabled}
      autoFocus={autoFocus}
      placeholder={placeholder}
      type={type}
      defaultValue={defaultValue}
      onChange={onChange}
      value={value}
      autoComplete={autoComplete}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
    />
  )
}
